import { type ReactNode } from 'react'
import { ThemeProvider as EmotionThemeProvider } from '@emotion/react'
import theme from '@/theme'

interface Props {
  children: ReactNode
}

export default function ThemeProvider({ children }: Props) {
  return <EmotionThemeProvider theme={theme}>{children}</EmotionThemeProvider>
}
